module.exports = __webpack_public_path__ + "static/media/arrow-left-icon.fb615e38.svg";